export default __webpack_public_path__ + "static/media/supplierStepImg.e3fe9c24.png";